module.exports = __webpack_public_path__ + "img/managedservices_catalogue.c168f03.png";